module.exports = __webpack_public_path__ + "img/p1_btn_go.48c36670.png";